export default __webpack_public_path__ + "locales/el-GR/Webhooks.json?hash=b6ba9da988b85c453db0d59f0960ac26";